///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ConfigObjectsDTO, ExportLinkConfigDTO, PlannerFeatureCollectionDTO } from '../../generated/shared-types.model';
import { GtthConfigProperties } from './config-properties.model';
import { AutoDesignPtMpModel } from './design/auto-design-ptmp.model';
import { GtthAutoDesignCommand } from '../../project-view-panel/logical-topology/engine/commands/design/auto-design-command';
import { GtthLogicalTopology } from '../../project-view-panel/logical-topology/entities/logical-topology';
import { ExportLinkConfig } from './export-link-config.model';
import { ProjectDialogComponent } from '../../projects/dialogs/project-dialog/project-dialog.component';
import { ProjectUnits } from '../../projects/project-enums';

export class LogicalConfigObjects implements ConfigObjectsDTO {
    properties: GtthConfigProperties;
    type: string;
}

export class LogicalConfigModel implements PlannerFeatureCollectionDTO {
    private static readonly DEFAULT_TU_RATE = 100;

    bbox: number[];
    crs: LogicalConfigObjects;
    name: string;

    static createDefault(layerContainsMhTg: boolean): LogicalConfigModel {
        const configProperties = new GtthConfigProperties();
        configProperties.tuRequiredRatePerLayer = [LogicalConfigModel.DEFAULT_TU_RATE];
        configProperties.defaultHeightPerLayer = [ProjectDialogComponent.DEFAULT_HEIGHT];
        configProperties.basic_discount = 0;
        configProperties.selectedProductsPerLayer = [];
        configProperties.designRingsPerLayer = [GtthAutoDesignCommand.createDesignRindsDTO()];
        configProperties.autodesignP2mpPerLayer = [AutoDesignPtMpModel.createAutoDesignPtMpModel(undefined, layerContainsMhTg)];
        configProperties.autoSetFrequenciesPerLayer = [GtthAutoDesignCommand.createAutoSetFrequenciesDTO()];
        configProperties.productUnits = ProjectUnits.METER;
        configProperties.activeLayerIdx = GtthLogicalTopology.DEFAULT_CONFIG_LAYER_INDEX;
        configProperties.isBlockedByPole = [false];
        configProperties.locationNamePrefix = ProjectDialogComponent.LOCATION_DEFAULT_PREFIX;
        configProperties.selectedServiceTypePerLayer = [];
        configProperties.selectedServiceYearsPerLayer = [];
        configProperties.saved_exportLinksConfig = new ExportLinkConfig({} as ExportLinkConfigDTO);
        configProperties.layersModeEnabled = false;
        configProperties.products_discounts = {};

        return {
            name: '',
            bbox: [0, 0, 1],
            crs: {
                type: 'name',
                properties: configProperties
            }
        };
    }
}
